import { render, staticRenderFns } from "./CustomTextTextarea.vue?vue&type=template&id=c8d34796&scoped=true"
import script from "./CustomTextTextarea.vue?vue&type=script&lang=js"
export * from "./CustomTextTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d34796",
  null
  
)

export default component.exports